import { ImageType } from "interfaces/content";

interface DataredeLogoImageProps {
  image: ImageType;
}

const DataredeLogoImage = ({ image }: DataredeLogoImageProps) => {
  return (
    <img
      src={`${process.env.REACT_APP_BASE_RELATIVE_ROUTES}/assets/${image.path}`}
      alt={image.alt}
    />
  );
};

export default DataredeLogoImage;
